// extracted by css-extract-rspack-plugin
export default {"container":"totalValueTooltip_container__Twp60","body":"totalValueTooltip_body__5Cl89"};